import type { DataGridContextType, GridState } from '@cmg/data-grid';
import { useCallback } from 'react';

import { useStoredGridState } from '../../../common/hooks/useStoredGridState';
import {
  CALENDAR_TABS,
  getCalendarTabStorageKey,
} from '../components/calendar-tabs/CalendarTabs.model';

export type Props = Readonly<{
  initialGridState: GridState | undefined;
  dataGridContext: DataGridContextType | undefined;
}>;

const useCalendarGridStoredStates = () =>
  CALENDAR_TABS.map(tab =>
    // CALENDAR_TABS is a constant array with a guaranteed order of elements.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useStoredGridState({
      storageKey: getCalendarTabStorageKey(tab),
      initialState: undefined,
    })
  );
export const useResetCalendarToDefault = ({ initialGridState, dataGridContext }: Props) => {
  const storedGridStates = useCalendarGridStoredStates();

  return useCallback(() => {
    if (!initialGridState) {
      return;
    }

    dataGridContext?.applyGridState(initialGridState);
    storedGridStates.forEach(({ handleClearState }) => handleClearState());
  }, [initialGridState, dataGridContext, storedGridStates]);
};
